import { PieChartAggregationStrategy } from '@constants/pages/user-defined-page/pie-chart-aggregation-strategy';
import { ChartPieType } from '@constants/pages/user-defined-page/chart-pie-type';
import { RangeType } from '@constants/pages/user-defined-page/range-type';
import { ChartAxisSettings } from '@models/pages/user-defined-page/chart-axis-settings';
import { ChartSignalEntry } from '@models/pages/user-defined-page/chart-signal-entry';

export class UserDefinedChartDetails {
  rangeType: RangeType = RangeType.MINUTE;
  rangeValue: number = 0;
  minY: number = 0;
  maxY: number = 0;
  axisYLabel: string = '';
  zones: ZoneConfig[] = [];
  minX: number = 0;
  maxX: number = 0;
  signals: ChartSignalEntry[] = [];
  axis: ChartAxisSettings[] = [];
  stringSignal?: ChartSignalEntry = new ChartSignalEntry();
  start: number = 0;
  end: number = 0;
  usingStaticData: boolean = false;
  staticData: string[] = [];
  statusEventPageId: number | undefined;
  statusEventPageName: string | undefined;
  imageWidgetImageNameOrMetaKey: string = '';
  imageWidgetBucketName: string = '';
  imageSourceType: ImageSourceType | undefined;
  mapWidgetZoomLevel: number = 0;
  mapWidgetMapStyle: google.maps.MapTypeId | undefined;
  gatewayId: string = '';
  pieChartType: ChartPieType = ChartPieType.STANDARD;
  aggregationStrategy: PieChartAggregationStrategy = PieChartAggregationStrategy.LATEST;
}

export class ZoneConfig {
  from: number = 0;
  to: number = 0;
  width: number = 0;
}

export enum ImageSourceType {
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  METAFIELD = 'METAFIELD',
}
